import AbstractCollection from "./abstractCollection";

class GameCollection extends AbstractCollection {
  /**
   *
   * @param {object} games
   */
  constructor(games) {
    super(games);
    this._allGamesAsArray = undefined;
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    if (!this.items) return false;
    const allGames = this.getAllGamesAsArray();
    if (!allGames) return false;
    return allGames.every((game) => game.hasLoaded);
  }

  /**
   *
   * @returns {?Team[]}
   */
  getAllGamesAsArray() {
    if (!this._allGamesAsArray) {
      const weeks = Object.keys(this.items);

      this._allGamesAsArray = !weeks || weeks.length === 0 ? null : [];

      weeks.forEach((week) => {
        this._allGamesAsArray = this._allGamesAsArray.concat(this.items[week]);
      });
    }

    return this._allGamesAsArray;
  }

  /**
   *
   * @param {string|number} week
   * @returns {?object}
   */
  getGamesByWeek(week) {
    return this.items[week];
  }

  /**
   *
   * @param {string} teamId
   * @returns {?object}
   */
  getGamesByTeam(teamId) {
    const weeks = Object.keys(this.items);

    if (!weeks || weeks.length === 0) return null;

    const games = {};
    weeks.forEach((week) => {
      let weekGames = this.items[week];
      games[week] = null;
      weekGames.forEach((game) => {
        if (game.hasTeam(teamId)) games[week] = game;
      });
    });

    return games;
  }
}

export default GameCollection;
